export enum NotificationProcessedStateEnum {
  BOUNCE = 'BOUNCE',
  COMPLAINT = 'COMPLAINT',
  DELIVERY = 'DELIVERY',
  FAILED = 'FAILED',
  PROCESSED = 'PROCESSED'
}
